module.exports = __webpack_public_path__ + "static/fonts/DS-DIGIT.223f2246.TTF";